/**
 * TASK-950 — Public site phone is the office line.
 * The repair demo line is not this number.
 * Override: REACT_APP_PUBLIC_AI_PHONE (E.164 or digits).
 */

export const PUBLIC_INFO_EMAIL = 'info@autoshops.com';

const DEFAULT_AI_PHONE_E164 = '+13213524048';

function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

/** E.164-ish tel: href (+1… when 10/11 US digits). */
export function publicAiPhoneTelHref(raw = process.env.REACT_APP_PUBLIC_AI_PHONE) {
  const fromEnv = (raw || '').trim();
  const source = fromEnv || DEFAULT_AI_PHONE_E164;
  const digits = digitsOnly(source);
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (source.startsWith('+') && digits.length >= 10) {
    return `+${digits}`;
  }
  return DEFAULT_AI_PHONE_E164;
}

/** Display like (321) 352-4048 */
export function publicAiPhoneDisplay(raw = process.env.REACT_APP_PUBLIC_AI_PHONE) {
  const tel = publicAiPhoneTelHref(raw);
  const digits = digitsOnly(tel);
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length === 10) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  }
  return tel;
}

export function publicInfoMailtoHref() {
  return `mailto:${PUBLIC_INFO_EMAIL}`;
}
